import { paymentApi } from "@/lib/payment-api";

export function useRechargeQuery(id?: string | null) {
  return paymentApi.useSuspenseQuery("get", "/v1/recharges/{id}", {
    params: {
      path: {
        id,
      },
    },
  });
}
